import { twJoin } from "tailwind-merge";

import { Info } from "@/design-system/Info";
import { isDefined } from "@/helpers/util";

interface StatProps {
  label: string;
  value: number | undefined;
  tooltip?: string;
  renderValue?: (value: number | undefined) => React.ReactNode;
  renderFooter?: () => React.ReactNode;
  placeholder?: boolean;
}

export function Stat({
  label,
  value,
  tooltip,
  renderValue,
  renderFooter,
  placeholder = false,
}: StatProps): React.ReactNode {
  let displayedValue: React.ReactNode = isDefined(value) ? value : "-";
  if (placeholder) {
    displayedValue = "...";
  } else if (renderValue) {
    displayedValue = renderValue(value);
  }

  return (
    <article className="flex flex-1 flex-col justify-between gap-space-xs rounded-md border border-border-default p-card-compact">
      <header className="flex flex-nowrap items-start justify-between gap-space-sm">
        <span className="text-caption text-text-secondary">{label}</span>
        {tooltip && (
          <span className="flex h-icon-control items-center">
            <Info tooltip={tooltip} variant="secondary" />
          </span>
        )}
      </header>
      <span className="text-figure-md text-text-brand-secondary">{displayedValue}</span>
      {renderFooter ? (
        <span className={twJoin("text-overline text-text-secondary", placeholder && "invisible")}>
          {renderFooter()}
        </span>
      ) : null}
    </article>
  );
}
